export default {
    environment: 'stage'
}